import { useEffect, useState } from "react";
import { useGetAllQuestionTechnologyQuery } from "src/services/QuestionTechnologyServices";

const useQuestionTechnology = () => {
  const [questionTechnology, setQuestionTechnology] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllQuestionTechnologyQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setQuestionTechnology(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { questionTechnology, isDataLoading };
};

export default useQuestionTechnology;
